import { useTranslation } from 'react-i18next'

import { Card, CardTitle, helpers, LineItemSelector } from '@reveni-io/reveni-ui'

import Notes from '@/parcels/components/Notes/Notes'

import ProductsCardMenu from './ProductsCardMenu/ProductsCardMenu'

const ProductsCard = ({
  lineItems = [],
  onPrepareParcel,
  onSplitParcel,
  allowPrepareParcel,
  allowAmendPackingStatus,
  allowSplitParcel,
  notes,
  isInbound,
}) => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>
        {t('Productos')}
        <ProductsCardMenu
          onPrepareParcel={onPrepareParcel}
          onSplitParcel={onSplitParcel}
          allowPrepareParcel={allowPrepareParcel}
          allowAmendPackingStatus={allowAmendPackingStatus}
          allowSplitParcel={allowSplitParcel}
          isInbound={isInbound}
        />
      </CardTitle>
      {helpers.joinLineItemsAndLineItemGroups(helpers.flattenLineItems(lineItems), [])?.map(item => (
        <LineItemSelector
          key={item.id}
          lineItem={item}
          clickable={false}
          showStatus={!isInbound}
          showIndex={true}
          showToggle={false}
        />
      ))}
      <Notes notes={notes} />
    </Card>
  )
}

export default ProductsCard
